import React from "react";
import { LayoutGrid } from "lucide-react";

/**
 * Renders a small lucide icon for sidebar nav chips / sort rows.
 */
const SidebarNavIcon = ({ icon: Icon = LayoutGrid, size = 12, className = "" }) => (
  <span className={`sidebar-nav-icon ${className}`.trim()} aria-hidden>
    <Icon size={size} strokeWidth={2.1} />
  </span>
);

export default SidebarNavIcon;
